import React from 'react';
import { InlineBanner, Box } from '@cad-arc';
import { useIntegratedForm } from '../use-integrated-form';

type InlineBannerProps = React.ComponentProps<typeof InlineBanner>;

type Props = {
    status?: InlineBannerProps['status'];
    title?: string;
};

export function FormLoadingErrorBanner(props: Props): React.ReactElement {
    const integratedForm = useIntegratedForm();
    return integratedForm.query.isError ? (
        <Box mb="1">
            <InlineBanner
                status={props.status ?? 'error'}
                title={props.title ?? 'An error occurred while loading data'}
            />
        </Box>
    ) : (
        <></>
    );
}
